import React from 'react';
import { usePageLastUpdated } from '../hooks/usePageLastUpdated';
import './TeachingPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2013-02-21', displayDate: 'February 21, 2013' };

const TeachingCard = ({ href, image, label }) => (
  <a
    href={href}
    className="teaching-card"
    style={{ backgroundImage: `url(${image})` }}
    aria-label={label}
  >
    <span className="visually-hidden">{label}</span>
  </a>
);

const TeachingPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  const spring2014Labs = [
    { href: '/teaching/upf/2014/architecture_and_signaling/lab/sip_registration/index.html', image: '/teaching/images/as_2014_lab_sip_registration.png', label: 'Lab SIP Registration' },
    { href: '/teaching/upf/2014/architecture_and_signaling/lab/sip_phone/index.html', image: '/teaching/images/as_2014_lab_sip_phone.png', label: 'Lab SIP Phone' },
    { href: '/teaching/upf/2014/architecture_and_signaling/lab/gsm/index.html', image: '/teaching/images/as_2014_lab_gsm.png', label: 'Lab GSM' },
    { href: '/teaching/upf/2014/architecture_and_signaling/lab/cdn/index.html', image: '/teaching/images/as_2014_lab_cdn.png', label: 'Lab Content Distribution Networks' },
  ];

  const spring2013Theory = [
    { href: '/teaching/upf/2013/architecture_and_signaling/h323/index.html', image: '/teaching/images/as_2013_h323.png', label: 'H.323' },
    { href: '/teaching/upf/2013/architecture_and_signaling/sip/index.html', image: '/teaching/images/as_2013_sip.png', label: 'SIP' },
    { href: '/teaching/upf/2013/architecture_and_signaling/gsm/index.html', image: '/teaching/images/as_2013_gsm.png', label: 'GSM and UMTS' },
  ];

  const spring2013Labs = [
    { href: '/teaching/upf/2013/architecture_and_signaling/lab/sip/index.html', image: '/teaching/images/as_2013_lab_sip.png', label: 'Lab SIP' },
    { href: '/teaching/upf/2013/architecture_and_signaling/lab/gsm/index.html', image: '/teaching/images/as_2013_lab_gsm.png', label: 'Lab GSM' },
  ];

  return (
    <>
      <div className="teaching-page" id="top">
        <h3>
          <a href="#2013">2013</a> | <a href="#2014">2014</a>
        </h3>

        <div id="2014">
          <h1>Spring 2014</h1>
          <h2>Labs</h2>
          <div className="teaching-grid">
            {spring2014Labs.map((item, i) => (
              <TeachingCard key={i} {...item} />
            ))}
          </div>
        </div>

        <div id="2013">
          <h1>Spring 2013</h1>
          <h2>Theory</h2>
          <div className="teaching-grid">
            {spring2013Theory.map((item, i) => (
              <TeachingCard key={i} {...item} />
            ))}
          </div>
          <h2>Labs</h2>
          <div className="teaching-grid">
            {spring2013Labs.map((item, i) => (
              <TeachingCard key={i} {...item} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeachingPage;
